import {formatDate, formatDateTime, addDays} from './dateUtils'

class ClipboardService {
    isAvailable(): boolean {
        return 'clipboard' in navigator
    }

    replacePlaceholders(text: string): string {
        let result = text

        const today = new Date()
        const tomorrow = addDays(today, 1)
        const yesterday = addDays(today, -1)

        result = result.replace(/\{\{currentDate\}\}/g, formatDate(today))
        result = result.replace(/\{\{today\}\}/g, formatDate(today))
        result = result.replace(/\{\{currentDateTime\}\}/g, formatDateTime(today))
        result = result.replace(/\{\{now\}\}/g, formatDateTime(today))
        result = result.replace(/\{\{tomorrow\}\}/g, formatDate(tomorrow))
        result = result.replace(/\{\{yesterday\}\}/g, formatDate(yesterday))

        return result
    }

    copyTo(text: string, withPlaceholders: boolean) {
        const replacedText = withPlaceholders ? this.replacePlaceholders(text) : text
        if (this.isAvailable()) {
            return navigator.clipboard.writeText(replacedText).catch(console.error)
        } else {
            return document.execCommand('copy', true, replacedText)
        }
    }
}

export const clipboardService = new ClipboardService()
